/**
 * ─────────────────────────────────────────────────────────────────────
 * FILE: src/pages/UserProfile.tsx
 * DESCRIPTION: User profile management page using Clerk's pre-built
 *              components for profile editing, security settings,
 *              and account management.
 * 
 * IMPORTS IN:
 * - src/App.tsx (Route: /profile)
 * 
 * @copyright 2025-2026 Anou. All rights reserved.
 * @author Anou
 * @version 1.0.0
 * @created 2025-01-15
 * ─────────────────────────────────────────────────────────────────────
 */

import { UserProfile as ClerkUserProfile } from '@clerk/react';

/**
 * UserProfile Component
 * Renders Clerk's pre-built user profile component with custom styling.
 * 
 * @returns {JSX.Element} User profile management interface
 */
const UserProfile: React.FC = () => {
  return (
    <div className="p-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Profile Settings</h1>
          <p className="text-gray-600">Manage your account settings and preferences</p>
        </div>

        <div className="card">
          <ClerkUserProfile
            appearance={{
              elements: {
                rootBox: 'w-full',
                card: 'shadow-none border-0',
                navbar: 'hidden',
                pageScrollBox: 'p-0',
                formButtonPrimary: 'bg-primary-600 hover:bg-primary-700',
                profileSectionTitle: 'text-lg font-semibold text-gray-900',
                profileSectionContent: 'space-y-4',
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
